// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSectionComponent_faqSection__xw5LI","gwSectionContainer":"FaqSectionComponent_gwSectionContainer__k3dR6"};